import React from "react";
import { MapPin, Phone, Building2, ChevronRight } from "lucide-react";

const Location = () => {
  const locations = [
    {
      city: "Pathankot",
      name: "Grand Cinemaz",
      address: "City Centre Mall, Dalhousie Road, Pathankot, Punjab",
      pincode: "145001",
      phone: "9056805305",
    },
    {
      city: "Ghaziabad",
      name: "Grand Cinemaz",
      address: "Nehru Nagar, D'Mart, Ghaziabad, Uttar Pradesh",
      pincode: "201001",
      phone: "8448619955",
    },
    {
      city: "Saharanpur",
      name: "Grand Cinemaz",
      address:
        "Old Kalapna Cinema Patel Nagar Ambala road Saharanpur, Uttar Pradesh",
      pincode: "247001",
      phone: "9306547136",
    },
    {
      city: "Una",
      name: "Grand Cinemaz",
      address: "The Gulmohar Grand, Una, Himachal Pardesh",
      pincode: "174306",
      phone: "6230301476",
    },
    {
      city: "Moga",
      name: "Grand Cinemaz Pvt. Ltd.",
      address:
        "Orbit Mall, Zeera Road, Dhallke, near City Park Palace, Suraj Nagar, Moga, Punjab",
      pincode: "142011",
      phone: "7652848272",
    },
  ];

  return (
    <section className="bg-gradient-to-b from-[#160b0b] via-[#0f172a] to-[#08101f] py-12 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8 md:mb-10 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-amber-400 text-sm md:text-base font-medium tracking-[0.18em] uppercase mb-2">
              Grand Cinemaz
            </p>
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight">
              Our Locations
            </h2>
            <p className="text-gray-400 mt-3 max-w-2xl text-sm md:text-base">
              Discover our premium cinema destinations across the region.
            </p>
          </div>

          <div className="hidden md:flex items-center gap-2 text-amber-300 text-sm">
            <span>Swipe to explore</span>
            <ChevronRight className="w-4 h-4" />
          </div>
        </div>

        {/* Slider */}
        <div className="relative">
          {/* left fade */}

          <div className="locations-slider flex gap-4 overflow-x-auto snap-x snap-mandatory pb-4 px-1">
            {locations.map((location, index) => {
              const mapQuery = `${location.name}, ${location.address}, ${location.city}, ${location.pincode}`;
              const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
                mapQuery,
              )}&output=embed`;
              const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                mapQuery,
              )}`;

              return (
                <div
                  key={index}
                  className="snap-start min-w-[290px] max-w-[290px] sm:min-w-[320px] sm:max-w-[320px] rounded-2xl overflow-hidden border border-white/10 bg-white/5 backdrop-blur-xl shadow-lg hover:shadow-amber-500/10 hover:border-amber-400/30 transition-all duration-300"
                >
                  <div className="relative h-40">
                    <iframe
                      src={mapUrl}
                      loading="lazy"
                      allowFullScreen
                      referrerPolicy="no-referrer-when-downgrade"
                      className="w-full h-full"
                      title={`Map of ${location.city}`}
                    />
                    <div className="absolute top-3 left-3">
                      <span className="inline-flex items-center rounded-full bg-black/60 backdrop-blur-md border border-white/10 px-3 py-1 text-[11px] font-semibold tracking-wide text-amber-300 uppercase">
                        {location.city}
                      </span>
                    </div>
                  </div>

                  <div className="p-4 sm:p-5">
                    <div className="flex items-start gap-3 mb-3">
                      <div className="w-10 h-10 rounded-xl bg-amber-500/10 flex items-center justify-center shrink-0">
                        <Building2 className="w-5 h-5 text-amber-400" />
                      </div>
                      <div className="min-w-0">
                        <h3 className="text-white text-lg font-semibold leading-snug">
                          {location.name}
                        </h3>
                      </div>
                    </div>

                    <button
                      onClick={() => window.open(mapLink, "_blank")}
                      className="w-full text-left rounded-xl border border-white/8 bg-white/[0.03] hover:bg-white/[0.06] transition-colors p-3 mb-3"
                    >
                      <div className="flex gap-3">
                        <MapPin className="w-4 h-4 text-amber-400 mt-1 shrink-0" />
                        <div>
                          <p className="text-sm text-gray-300 leading-6">
                            {location.address}
                          </p>
                          <p className="text-xs text-amber-200 mt-1 font-medium">
                            PIN: {location.pincode}
                          </p>
                        </div>
                      </div>
                    </button>

                    <div className="flex items-center justify-between rounded-xl border border-white/8 bg-slate-900/40 px-3 py-3">
                      <div className="flex items-center gap-2 min-w-0">
                        <Phone className="w-4 h-4 text-amber-400 shrink-0" />
                        <a
                          href={`tel:${location.phone}`}
                          className="text-sm font-medium text-white hover:text-amber-300 transition-colors"
                        >
                          {location.phone}
                        </a>
                      </div>

                      <a
                        href={`tel:${location.phone}`}
                        className="text-xs font-semibold px-3 py-1.5 rounded-full bg-amber-500 text-black hover:bg-amber-400 transition-colors"
                      >
                        Call
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-400">
            Visit your nearest Grand Cinemaz and enjoy a luxurious movie
            experience.
          </p>
        </div>
      </div>

      <style jsx>{`
        .locations-slider {
          scrollbar-width: thin;
          scrollbar-color: rgba(251, 191, 36, 0.65) transparent;
        }

        .locations-slider::-webkit-scrollbar {
          height: 8px;
        }

        .locations-slider::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.06);
          border-radius: 999px;
        }

        .locations-slider::-webkit-scrollbar-thumb {
          background: linear-gradient(
            90deg,
            rgba(252, 211, 77, 0.95),
            rgba(245, 158, 11, 0.95),
            rgba(251, 191, 36, 0.95)
          );
          border-radius: 999px;
          border: 1px solid rgba(255, 255, 255, 0.12);
          box-shadow: 0 0 12px rgba(251, 191, 36, 0.45);
        }

        .locations-slider::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(
            90deg,
            rgba(253, 224, 71, 1),
            rgba(251, 146, 60, 1),
            rgba(252, 211, 77, 1)
          );
        }
      `}</style>
    </section>
  );
};

export default Location;
